import { render, staticRenderFns } from "./ClientLp.vue?vue&type=template&id=58886889"
import script from "./ClientLp.vue?vue&type=script&lang=js"
export * from "./ClientLp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports